import React from 'react'

const CookieyesPolicyTable = () => {
  return (
    <div className='cky-audit-table-element' />
  )
}

export default CookieyesPolicyTable
